<template>
    <div class="BottomContent">
        <div v-for="(v, i) in listData" :key="i"
            :style="{ height: listData.length === 1 ? '100%' : '', width: listData.length === 1 ? '100%' : '', borderRightWidth: [3, 7].includes(i) ? 0 : '1px' }">
            <div class="name">{{ v }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomContent",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
    },
    components: {},
    data() {
        return {}
    },
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.BottomContent {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
    flex-wrap: wrap;
    color: #fff;

    &>div {
        width: 24%;
        height: 60px;
        border-right: 1px solid #4D80BE;
        @include setFlexCenter;
        padding-right: 2px;
        .name {
            height: 16px;
            line-height: 16px;
            font-size: 15px;
            font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            text-align: center;
        }
    }
}
</style>